import React from "react";

import "./researchCard.css";

const ResearchCard = ({
  title,
  photo,
  description,
  startDate,
  endDate,
  leadResearcher,
  funding,
  status,
  email,
  phone,
}) => {
  return (
    <div className="col-md-6 col-lg-3">
      <article className="course">
        <div className="course-header">
          <img src={photo} alt={title} className="rounded" />
          <span className="theme-bg px-2 py-1 fw-bold rounded">{status}</span>
        </div>
        <h3 className="course-title my-3 fs-5">{title}</h3>
        <div className="course-footer">
          <div className="footer-creator">
            <span>{description}</span>
            <ul>
              <li>
                <i className="theme-clr me-1 fas fa-graduation-cap"></i>
                {leadResearcher} 
              </li>
              <li>
                <i className="theme-clr me-1 fa fa-money-bill-alt"></i>
                {funding}
              </li>
              <li>
                <i className="theme-clr me-1 fas fa fa-envelope"></i>
                {email} 
              </li>
              <li>
                <i className="theme-clr me-1 fa fa-phone"></i>
                {phone}
              </li>
            </ul>
          </div>
          <div className="footer-stars mt-2 d-flex">
            <span className="me-1 fw-bold">({startDate})</span>
          </div>
        </div>
      </article>

      {/* <Certificate image={certificate} modal={show} /> */}
    </div>
  );
};

export default ResearchCard;
